import { useRef } from 'react';
import { useMapEvent } from 'react-leaflet';

const LongPressHandler = ({ onLongPress, delay = 500 }) => {
  const timerRef = useRef(null);
  const movedRef = useRef(false);

  // --- PC用 ---
  useMapEvent('mousedown', (e) => {
    movedRef.current = false;
    timerRef.current = setTimeout(() => {
      if (!movedRef.current) {
        if (onLongPress) {
          onLongPress(e.latlng);
        }
      }
    }, delay);
  });

  useMapEvent('mousemove', () => {
    // ユーザーがマップをドラッグして動かしたらロングタップ判定をキャンセル
    movedRef.current = true;
  });

  useMapEvent('mouseup', () => {
    clearTimeout(timerRef.current);
  });

  useMapEvent('mouseout', () => {
    clearTimeout(timerRef.current);
  });

  // --- モバイル用 ---
  useMapEvent('contextmenu', (e) => {
    if (onLongPress) {
      onLongPress(e.latlng);
    }
  });

  return null;
};
export default LongPressHandler;
